module.exports = __webpack_public_path__ + "static/media/stage-2x.56ac92b7.jpg";